<template>
  <div class="score-entry-student">
    <div class="btn-list">
      <span style="margin-right: 5px; font-weight: bold">学生姓名</span>
      <el-select v-model="selectStudent" filterable placeholder="请选择学生" @change="studentChange">
        <el-option v-for="(item, index) in gradeStudentList" :key="index" :label="item.studentName" :value="item.id">
        </el-option>
      </el-select>
    </div>
    <el-table :data="courseFullList" border style="width: 300px; margin: 0 auto; max-height: 300px; overflow-y: auto">
      <el-table-column label="科目" prop="courseName"></el-table-column>
      <el-table-column label="成绩">
        <template slot-scope="scope">
          <el-input v-model="scope.row.score"></el-input>
        </template>
      </el-table-column>
    </el-table>
    <div class="btn-list">
      <el-button type="primary" plain @click="back">返回</el-button>
      <el-button type="primary" @click="scoreEntryStudentSubmit">确认</el-button>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    "isChooseContainerShow",
    "courseFullList",
    "gradeStudentList",
    "gradeSelectList",
  ],
  data() {
    return {
      selectStudent: "", // 选中的学生
      studentData: {},
      classId: "",
    };
  },
  methods: {
    // 选中学生切换
    studentChange(e) {
      // console.log("选中学生切换:", this.gradeStudentList.find(item=> item.id == e).classId);
      this.studentData = this.gradeStudentList.find(
        (item) => item.id === this.selectStudent
      );
      this.classId = this.studentData.classId;
      this.getStudentScoreAchievementDetail(e);
    },
    getStudentScoreAchievementDetail(id) {
      let data = {
        examInfoId: this.gradeSelectList[0],
        studentId: id,
        classId: this.classId,
      };

      this.post(this.$url.getStudentScoreAchievementDetail, data).then(
        (res) => {
          if (res.code !== 200) {
            this.courseFullList.forEach((item) => {
              item.score = "";
            });
            return;
          }
          // 将学生详情中的成绩赋值到对应的分制中
          if (res.data.subAnalysisList && res.data.subAnalysisList.length > 0) {
            res.data.subAnalysisList.forEach((item) => {
              this.courseFullList.forEach((cItem) => {
                if (item.courseName === cItem.courseName) {
                  cItem.score = item.score;
                }
              });
            });
          } else {
            this.courseFullList.forEach((item) => {
              item.score = "";
            });
          }
        }
      );
    },
    // 单个学生录入成绩点击提交
    scoreEntryStudentSubmit() {
      console.log(this.studentData);

      let scores = [];
      this.courseFullList.forEach((item) => {
        if (item.score !== "") {
          scores.push({
            courseName: item.courseName,
            courseId: item.courseId,
            score: +item.score,
            classId: this.studentData.classId,
            gradeId: this.studentData.gradeId,
          });
        }
      });
      let data = {
        studentName: this.studentData.studentName,
        studentNumber: this.studentData.studentNumber,
        examInfoId: this.courseFullList[0].examInfoId,
        scores,
      };
      // console.log("单个学生录入成绩点击提交:", data);
      this.$emit("scoreEntryStudentSubmit", data);
    },
    // 返回选择录入方式
    back() {
      // 遍历courseFullList中的每个item，将score属性设置为空
      this.courseFullList.forEach((item) => {
        item.score = ""; // 或者 item.score = undefined;
      });
      this.$emit("update:isChooseContainerShow", true);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./scoreEntryStudent.scss";
</style>